<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          :isBr="false"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-radio-group
            v-if="inAdManager"
            v-model="filter.dimension"
            @input="dimensionChange($event)"
            :options="AdNegKeywordEnum.SP.dimensionOption"
        ></gj-radio-group>
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SP" @change="campaignSelectChange($event)" width="180px"></ad-campaign-select>
        <ad-group-select ref="groupSelect" v-model="groupIds" :marketId="marketId" :campaignId="campaignId" v-if="!inGroup" v-show="showGroup" adType="SP"></ad-group-select>
        <gj-select
            v-model="filter.status"
            :options="AdNegKeywordEnum.SP.statusOptionNew"
            placeholder="状态"
        ></gj-select>
        <gj-select
            v-model="filter.matchType"
            :options="AdNegKeywordEnum.SP.matchTypeOption"
            placeholder="匹配类型"
        ></gj-select>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 0, text: '模糊查询'},
              {id: 1, text: '精准查询'},
            ]"
        ></gj-select-input>
        <template v-if="!$permission('adsSpCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :helpName="helpName"
          >
          <template #before>
            <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
          </template>
          </gj-tool-group>
          <!-- :download="$permission('product:export')" download-url="广告导出地址" :download-params="globalParams" -->
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add">
        新增否定关键词
      </gj-button>
      <gj-button
          v-if="$permission('adsSpCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdNegKeywordEnum.SP.status.ENABLE, AdNegKeywordEnum.SP.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns"
          :sort-gjtable="$refs.gjTable"
      >
        <template #before>
          <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
        </template>
      </gj-tool-group>
      <!-- :download="$permission('product:export')" download-url="广告导出地址" :download-params="globalParams" -->
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSpCampaigns:addOrUpdate')"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :pagination="pagination"
          :scroll-y="{mode: 'default', gt: 100 }"
          :selectable="notEqSelectable('state', AdNegKeywordEnum.SP.status.ARCHIVE)"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:negKeywordName="{row}">
          {{row.keywordText | defaultShow}}
          <gj-copy-icon :content="row.keywordText"></gj-copy-icon>
        </template>
        <template v-slot:belongGroup="{row}">
          <app-sp-ad-route-link
              :ad-group-manager="{marketId, campaign: row, group: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sp-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, currencySymbolMixin, inAdManagerMixin,
    inCampaignMixin,
    inGroupMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin, resizeMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {queryMixin, selectionMixin} from "@/minxins";
  import {AdNegKeywordEnum, AdLog} from "../../../common/enum";
  import AppAddSpAdNegKeyword from "../../common/modal/add/neg-keyword/add-ad-neg-keyword";
  import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
  import {adStore} from "../../../common/store";
  import { SP } from "@/api/ad";
  import AppSpAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import AdGroupSelect from "modules/ad/common/components/ad-group-select.vue"
  import AppAdLogModal from "../../../common/modal/log/ad-log-new-modal";

  export default {
    name: "app-sp-ad-neg-keyword",
    components: {AppSpAdRouteLink, AdCampaignSelect, AdGroupSelect},
    mixins: [
      inMarketMixin, inPortfolioMixin, resizeMixin,
      inCampaignMixin, inGroupMixin, tableNameMixin,
      selectionMixin, adBaseDataMixin,
      queryMixin, currencySymbolMixin, initDateMixin,
      inAdManagerMixin
    ],
    created() {
      this.setColumns();
      this.group && (this.filter.dimension = AdNegKeywordEnum.SP.dimension.GROUP)

    },
    inject: [ 'getCornerMark' ],
    data() {
      return {
        helpName:'spadmanager',
        lastUpdatedDate: "",
        countryName: '',
        campaignIds: [],
        groupIds: [],
        showGroup: false,
        tableData: [],
        columns: [],
        AdNegKeywordEnum: AdNegKeywordEnum,
        filter: {
          dimension: AdNegKeywordEnum.SP.dimension.CAMPAIGN,
          status: AdNegKeywordEnum.SP.statusNew.ENABLE,
          matchType: null,
          keyword: {
            key: 0,
            value: null
          },
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-sp-ad-neg-keyword',
        notStorage: true
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          groupIds: [],
          filter: {
            dimension: this.filter.dimension,
            status: AdNegKeywordEnum.SP.statusNew.ENABLE,
            matchType: null,
            keyword: {
              key: 0,
              value: null
            }
          }
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) return false;
        this.getCornerMark();
        this.getTablePage();
      },
      async getTablePage() {
        this.loading = true;
        // 处理广告活动 & 广告组
        let campaignIds = this.campaignIds || [];
        let groupIds = this.groupIds || [];
        this.campaignId && (campaignIds = [ this.campaignId ]);
        this.groupId && (groupIds = [ this.groupId ]);
        // 构造查询参数
        const params = {
          model: {
            campaignIds,
            groupIds,
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            states: this.filter.status ? JSON.parse(this.filter.status) : null,
            matchType: defaultVal(this.filter.matchType, null),
            searchType: this.filter.keyword.key,
            keywordText: this.filter.keyword.value,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        try {
          let res = {};
          if (this.filter.dimension === AdNegKeywordEnum.SP.dimension.CAMPAIGN) {
            res = await SP.campaignNegativeKeywordsPage(params);
          }else {
            res = await SP.negativeKeywordsPage(params);
          }
          this.tableData = this.currencySymbolMixin(res.data.records, adStore.SP.currencySymbol);
          this.lastUpdatedDate = res.data.lastUpdatedDate;
          this.countryName = res.data.countryName;
          this.pagination = this.getPagination(res.data);
        } catch (error) {
          console.warn(error);
        } finally {
          this.loading = false;
        }
      },
      // 广告活动下拉改变
      campaignSelectChange(e) {
        this.groupIds = [];
        let afferent = {
          campaignIds: e
        }
        this.$refs.groupSelect.getOptions('SP', afferent)
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      groupChange(groupId) {
        if (isMeaningful(groupId)) {
          this.filter.dimension = AdNegKeywordEnum.SP.dimension.GROUP;
        }
        this.$gjNoticeQuery();
      },
      dimensionChange(dimension) {
        this.showGroup = dimension == 1
        this.groupIds = [];
        this.campaignIds = [];
        this.setColumns();
        this.$gjNoticeQuery();
      },
      setColumns() {
        this.columns = [
          {...adFields.negKeywordName, copyable: false},
          {...adFields.status, header: '状态', field: 'option:state', options: AdNegKeywordEnum.SP.statusOption},
          {...adFields.matchType, options: AdNegKeywordEnum.SP.matchTypeOption},
          this.inGroup || this.filter.dimension === AdNegKeywordEnum.SP.dimension.CAMPAIGN ? null : adFields.belongGroup,
          this.inCampaign ? null : adFields.belongCampaign,
          // {...adFields.startDate, help: null},
          adFields.op,
        ].filter(e => e !== null);
      },
      add() {
        this.$gjCreate(AppAddSpAdNegKeyword, {
          props: {
            marketId: this.marketId,
            dimension: this.filter.dimension,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              const params = {
                marketId: this.marketId,
                params: this.selectedRows.map(e => ({
                  keywordId: e.keywordId,
                  state: AdNegKeywordEnum.SP.status.ARCHIVE
                }))
              };
              Promise.resolve(this.filter.dimension)
                .then((dimension) => {
                  if (dimension === AdNegKeywordEnum.SP.dimension.CAMPAIGN) {
                    return SP.campaignNegativeKeywordsEdit(params);
                  } else {
                    return SP.negativeKeywordsEdit(params);
                  }
                })
                .then(({ data, msg, isError}) => {
                  this.$gjMessage[isError ? 'error' : 'success'](msg);
                  this.clearCheckboxRow();
                  data && data.forEach(item => {
                    let element = this.tableData.find(e => e.keywordId === item.keywordId) || {};
                    Object.assign(element, item);
                  });
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      viewLog(row) {
        let campaignId = this.campaignId || row?.campaignId;
        let groupId = this.groupId || row?.groupId;
        let objectName = row?.keywordText;
        this.$gjCreate(AppAdLogModal, {
          props: {
            campaignId,
            groupId,
            objectName,
            marketId: this.marketId,
            adType: 'SP',
            objectType: AdLog().objCell[ this.filter.dimension === AdNegKeywordEnum.SP.dimension.CAMPAIGN ? 'campaignNegativeKeyword' : 'negativeKeyword'],
            name: isMeaningful(row) ? row.keywordText : '',
          }
        });
        // this.$gjCreate(AppAdLogModal, {
        //   props: {
        //     marketId: this.marketId,
        //     campaignId: this.campaignId,
        //     groupId: this.groupId,
        //     name: isMeaningful(row) ? row.keywordText : '',
        //     opId: isMeaningful(row) ? row.keywordId : null,
        //     adType: LOG_OP_TYPE.SP,
        //     object: this.filter.dimension === AdNegKeywordEnum.SP.dimension.CAMPAIGN
        //       ? LOG_OP_TYPE.SP.CAMPAIGN_NEG_KEYWORD
        //       : LOG_OP_TYPE.SP.NEG_KEYWORD
        //   }
        // });
      }
    }
  }
</script>

<style scoped>

</style>
